import { FaHome } from "react-icons/fa";
export const navItems = [
  {
    id: 0,
    title: "Inicio",
    path: "/Inicio",
    cName: "nav-item",
    icon: <FaHome className="icon-style"/> 
  },
  {
    id: 1,
    title: "Dinámicas",
    path: "/Dinamicas",
    cName: "nav-item",
    icon: <FaHome className="icon-style"/> 
  },

  //{
   // id: 2,
  //  title: "Jurisprudencia",
   // path: "/Jurisprudencia",
   // cName: "nav-item",
  //  icon: <FaHome className="icon-style"/> 
 // },
  {
    id: 3,
    title: "Acerca de",
    path: "/Sobre",
    cName: "nav-item",
    icon: <FaHome className="icon-style"/> 
  },
  
];
